import 'swiper/css/bundle'
import '../../scss/components/swiperCarousel'
import Swiper, { Navigation, Lazy, Autoplay, Pagination } from 'swiper'

// configure Swiper to use modules
Swiper.use([Navigation, Lazy, Autoplay, Pagination])

// Pass in the objects to merge as arguments.
// For a deep extend, set the first argument to `true`.
const extend = function () {
  // Variables
  const extended = {}
  let deep = false
  let i = 0
  const length = arguments.length
  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0]
    i++
  }
  // Merge the object into the extended object
  const merge = function (obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop])
        } else {
          extended[prop] = obj[prop]
        }
      }
    }
  }
  // Loop through each object and conduct a merge
  for (; i < length; i++) {
    const obj = arguments[i]
    merge(obj)
  }
  return extended
}

// gestion des carousel
const els = document.getElementsByClassName('swiper-carousel')
for (const container of els) {
  const options = container.hasAttribute('data-plugin-options') ? container.getAttribute('data-plugin-options').replace(/'/g, '"') : { }
  // default carousel configuration
  const defaults = {
    // Enable navigation
    navigation: {
      nextEl: container.getElementsByClassName('swiper-button-next')[0],
      prevEl: container.getElementsByClassName('swiper-button-prev')[0]
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      clickable: true
    },
    slidesPerView: 1,
    // slidesPerGroup: 3,
    spaceBetween: 15,
    loop: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadOnTransitionStart: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    //    breakpoints: {
    //      576: {
    //        slidesPerView: 2
    //      },
    //      768: {
    //        slidesPerView: 2
    //      },
    //      992: {
    //        slidesPerView: 3
    //      },
    //      1200: {
    //        slidesPerView: 3
    //      },
    //      1400: {
    //        slidesPerView: 4
    //      }
    //    }
    on: {
      init: function () {
        /* global Waypoint */
        Waypoint.refreshAll()
      },
      lazyImageReady: function (swiper, slide, img) {
        // https://github.com/nolimits4web/swiper/issues/5667
        if (img.complete) {
          swiper.update()
        } else {
          img.addEventListener('load', function () {
            swiper.update()
          })
        }
      }
    }
  }
  const obj = options.length > 0 ? JSON.parse(options) : { }
  const config = extend(true, defaults, obj)
  //  const slides = container.getElementsByClassName('swiper-slide')
  //  for (const slide of slides) {
  //    slide.classList.remove('d-none')
  //  }
  const slider = new Swiper(container, config)
  slider.init()
}
